(function(){
  'use strict';

  // ---- State ----
  var drawerOpen = false;

  // ---- DOM refs ----
  function el(sel){ return document.querySelector(sel); }
  function els(sel){ return document.querySelectorAll(sel); }
  var drawer, overlay, body, items, footer, subtotal, emptyMsg, countBadges;

  function cacheDom(){
    drawer    = el('[data-cart-drawer]');
    overlay   = el('[data-cart-overlay]');
    body      = el('[data-cart-body]');
    items     = el('[data-cart-items]');
    footer    = el('[data-cart-footer]');
    subtotal  = el('[data-cart-subtotal]');
    emptyMsg  = el('[data-cart-empty]');
    countBadges = els('[data-cart-count]');
  }

  // ---- Drawer open / close ----
  function openDrawer(){
    if(!drawer) return;
    drawerOpen = true;
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeDrawer(){
    if(!drawer) return;
    drawerOpen = false;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ---- Money formatting ----
  function formatMoney(cents){
    return '$' + (cents / 100).toFixed(2);
  }

  // ---- Fetch cart and render ----
  function refreshCart(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(renderCart)
      .catch(function(){ /* silent */ });
  }

  function renderCart(cart){
    updateCount(cart.item_count);
    if(!items) return;

    if(cart.item_count === 0){
      items.innerHTML = '';
      if(emptyMsg) emptyMsg.style.display = '';
      if(footer) footer.style.display = 'none';
      return;
    }

    if(emptyMsg) emptyMsg.style.display = 'none';
    if(footer) footer.style.display = '';
    if(subtotal) subtotal.textContent = formatMoney(cart.total_price);

    var html = '';
    cart.items.forEach(function(item){
      html += '<div class="pg-cart-item" data-key="' + item.key + '">';
      html += '<div class="pg-cart-item-img">';
      if(item.image){ html += '<img src="' + item.image.replace(/(\.[^.]+)$/, '_180x$1') + '" alt="' + item.title + '">'; }
      html += '</div>';
      html += '<div class="pg-cart-item-details">';
      html += '<div class="pg-cart-item-title">' + item.product_title + '</div>';
      if(item.variant_title){ html += '<div class="pg-cart-item-variant">' + item.variant_title + '</div>'; }
      html += '<div class="pg-cart-item-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '<div class="pg-cart-qty">';
      html += '<button class="pg-cart-qty-btn" data-change="-1" data-key="' + item.key + '" aria-label="Decrease quantity">-</button>';
      html += '<span class="pg-cart-qty-val">' + item.quantity + '</span>';
      html += '<button class="pg-cart-qty-btn" data-change="1" data-key="' + item.key + '" aria-label="Increase quantity">+</button>';
      html += '</div>';
      html += '</div>';
      html += '<button class="pg-cart-remove" data-key="' + item.key + '" aria-label="Remove item">&times;</button>';
      html += '</div>';
    });
    items.innerHTML = html;
  }

  function updateCount(count){
    countBadges.forEach(function(badge){
      if(count > 0){
        badge.textContent = count;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  // ---- Cart API helpers ----
  function addToCart(id, qty, sellingPlan){
    var data = { id: parseInt(id, 10), quantity: qty || 1 };
    if(sellingPlan) data.selling_plan = parseInt(sellingPlan, 10);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function(r){
      if(!r.ok) return r.json().then(function(err){ throw new Error(err.description || 'Could not add to cart'); });
      return r.json();
    });
  }

  function changeQty(key, qty){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); })
      .then(renderCart);
  }

  // ---- Event listeners ----
  function init(){
    cacheDom();

    // Open drawer from cart icon
    document.addEventListener('click', function(e){
      var toggle = e.target.closest('.pg-cart-toggle');
      if(toggle){
        e.preventDefault();
        openDrawer();
        return;
      }
    });

    // Close drawer
    document.addEventListener('click', function(e){
      if(e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')){
        closeDrawer();
      }
    });

    // Add-to-cart forms
    document.addEventListener('submit', function(e){
      var form = e.target.closest('.pg-atc-form');
      if(!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var origText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      var formData = new FormData(form);
      var id = formData.get('id');
      var qty = formData.get('quantity') || 1;
      var sellingPlan = formData.get('selling_plan');

      addToCart(id, parseInt(qty, 10), sellingPlan)
        .then(function(){
          btn.textContent = 'Added!';
          openDrawer();
          setTimeout(function(){ btn.textContent = origText; btn.disabled = false; }, 1500);
        })
        .catch(function(err){
          btn.textContent = origText;
          btn.disabled = false;
          alert(err.message);
        });
    });

    // Quantity +/- and remove in drawer
    document.addEventListener('click', function(e){
      var qtyBtn = e.target.closest('.pg-cart-qty-btn');
      if(qtyBtn){
        var key = qtyBtn.dataset.key;
        var change = parseInt(qtyBtn.dataset.change, 10);
        var valEl = qtyBtn.parentElement.querySelector('.pg-cart-qty-val');
        var current = parseInt(valEl.textContent, 10);
        var newQty = Math.max(0, current + change);
        changeQty(key, newQty);
        return;
      }

      var removeBtn = e.target.closest('.pg-cart-remove');
      if(removeBtn){
        changeQty(removeBtn.dataset.key, 0);
      }
    });

    // Initial badge count
    refreshCart();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
